import { jsx as _jsx } from "react/jsx-runtime";
import { Redirect, Route, useLocation } from 'react-router-dom';
import Logger from '../lib/Logger';
const PAGE_ID_QUERY = 'page_id';
const LOG = Logger.getLogger('FacebookCrmRoute');

const FacebookCrmRoute = props => {
  const {
    hash,
    search
  } = useLocation();
  const searchParams = new URLSearchParams(search);

  if (!searchParams.has(PAGE_ID_QUERY)) {
    LOG.error('Invalid fb-crm URL not containing page_id.', {
      extra: {
        currentUrl: window.location.toString(),
        documentReferrer: document.referrer
      }
    });
    searchParams.delete(PAGE_ID_QUERY);
    return /*#__PURE__*/_jsx(Redirect, {
      to: {
        pathname: `/`,
        search: searchParams.toString(),
        hash
      }
    });
  }

  return /*#__PURE__*/_jsx(Route, Object.assign({}, props));
};

export default FacebookCrmRoute;